module.exports = __webpack_public_path__ + "static/assets/dee96871c40ed233491da7530f46e7b7.png";